var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1C0 0.447715 0.447715 0 1 0H29C29.5523 0 30 0.447715 30 1V2C30 2.55228 29.5523 3 29 3H1C0.447716 3 0 2.55228 0 2V1ZM0 12C0 11.4477 0.447715 11 1 11H29C29.5523 11 30 11.4477 30 12V13C30 13.5523 29.5523 14 29 14H1C0.447716 14 0 13.5523 0 13V12ZM1 22C0.447715 22 0 22.4477 0 23V24C0 24.5523 0.447716 25 1 25H29C29.5523 25 30 24.5523 30 24V23C30 22.4477 29.5523 22 29 22H1Z",
    fill: "#294764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/MenuIcon.14f28b12e1d00417ddd12888c6984520.svg";
export { ForwardRef as ReactComponent };